import mixpanel from 'mixpanel-browser';
import axios from 'axios';

import { getBaseUrl } from './commonFunctions';

const TOKEN = (process.env.REACT_APP_MIXPANELTOKEN as string) || '';

mixpanel.init(TOKEN, {
  opt_out_tracking_by_default: true,
});

export { mixpanel };
const mixpanelFunction = (
  eventName: any,
  page: any,
  backwardCompatibilityParam: any,
  object: any = {},
) => {
  let properties = {};
  if (typeof backwardCompatibilityParam === 'object')
    properties = backwardCompatibilityParam;
  else properties = object;
  mixpanel.track(eventName, { page, ...properties });
};
export default mixpanelFunction;

function mixpanelBackend(eventName: any, page: any, object: any = {}) {
  const accessToken = localStorage.getItem('access_token');
  const baseURL = getBaseUrl();

  const fetch = axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
      'Content-Encoding': 'gzip',
      Authorization: `Bearer ${accessToken}`,
    },
  });
  const email = localStorage.getItem('userEmail');
  const prodigal = localStorage.getItem('user_name');
  const domain = localStorage.getItem('domain') as string;

  if (domain === 'prodigaltech.com') return;

  let ip;
  try {
    ip = localStorage.getItem('ipv4');
  } catch {
    ip = '';
  }

  const properties = {
    version: '0.0.1',
    server: getBaseUrl(),
    ip,
    email,
    user_name: prodigal,
    domain:
      domain?.split('.') && domain?.split('.')?.length > 0
        ? domain.split('.')[0]
        : domain,
    ...object,
  };

  fetch.post('mixpanel/', {
    eventName,
    properties: { page, ...properties },
  });
}
export { mixpanelBackend };
